<div class="container-fluid mt-5">

    <div class="row">
        <div class="card">
            <div class="card-body">
                <h4 class="letra-azul">Tablas Pivote</h4>
                <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                <hr class="mt-1" style="border-top: 6px solid var(--app-oscuro, #0c7cb3);">
                <div class="row mt-3">
                    <div class="offset-10 col-2" style="text-align: right;" [ngClass]="isFlex ? 'd-none':'d-block'">
                        <button type="button" title="Filtrar" (click)="open()"
                            class="btn btn-info btn-label waves-light">
                            <i class="fas fa-filter label-icon" style="pointer-events:none ;"></i>
                            Filtrar
                        </button>
                    </div>
                </div>
                <div class="row mt-1" [ngClass]="isFlex ? 'd-none':'d-block'">
                    <div class="table-responsive" style="border: 1px solid gray; border-radius: 10px; padding: 0;">
                        <table class="table-avatar mb-0 table-striped">
                            <thead>
                                <tr>
                                    <td (click)="ordendes('SYS02DES')" *ngIf="!order_mostrar">Descripción <i
                                            class="fa fa-arrow-down-wide-short"></i></td>
                                    <td (click)="ordenasc('SYS02DES')" *ngIf="order_mostrar">Descripción <i
                                            class="fa fa-arrow-up-wide-short"></i></td>
                                    <td (click)="ordendes('SYS02CON')" *ngIf="!order_mostrar">Consecutivo de reporte <i
                                            class="fa fa-arrow-down-wide-short"></i></td>
                                    <td (click)="ordenasc('SYS02CON')" *ngIf="order_mostrar">Consecutivo de reporte <i
                                            class="fa fa-arrow-up-wide-short"></i></td>
                                    <td (click)="ordendes('A02COD')" *ngIf="!order_mostrar">Tabla <i
                                            class="fa fa-arrow-down-wide-short"></i></td>
                                    <td (click)="ordenasc('A02COD')" *ngIf="order_mostrar">Tabla <i
                                            class="fa fa-arrow-up-wide-short"></i></td>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container
                                    *ngFor="let pantalla of pantallas | paginate: {id:'flex1', currentPage: currentPage, itemsPerPage: 10 }">
                                    <tr (click)="abrirFlex(pantalla.SYS02CON)">
                                        <td>{{pantalla.SYS02DES}}</td>
                                        <td>{{pantalla.SYS02CON}}</td>
                                        <td>{{pantalla.A02COD}}</td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    <div class="row mt-3">
                        <div class="offset-md-4 col-md-4">
                            <pagination-controls (pageChange)="pageChange($event)" id='flex1' previousLabel="Anterior"
                                nextLabel="Siguiente" style="text-align: center;" responsive="true">
                            </pagination-controls>
                        </div>
                    </div>
                </div>

                <div class="row mt-2" [ngClass]="isFlex ? 'd-block':'d-none'">
                    <div class="row">
                        <div class="col-2">
                            <button type="button" class="btn btn-secondary btn-label waves-light" (click)="atras()"><i
                                    class="fa fa-arrow-left label-icon" style="pointer-events:none;"></i> Atrás</button>
                        </div>
                    </div>

                    <ng-container *ngIf="filtrosCampo.length > 0">
                        <div ngbAccordion *ngIf="filtrosCampo[0].FiltrosAvanzado.length > 0" class="mt-2"> 
                            <div ngbAccordionItem [destroyOnHide]="false">
                                <h6 ngbAccordionHeader>
                                <button ngbAccordionButton>
                                    <div class="text-end w-100">
                                    <i class="fa fa-filter fa-xl me-2"></i>
                                    </div>
                                </button>
                                </h6>
                                <div ngbAccordionCollapse>
                                <div ngbAccordionBody>
                                    <ng-template>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                                                <div class="card mb-0" style="background-color: var(--app-muy-claro, #edf4f9);box-shadow: 0px 3px 8px;">
                                                    <div class="card-body">
                                                        <app-filtrocampo [form_template]="filtrosCampo"
                                                            [blnAccionbuscar]="accionFiltrar" [strListener]="SYS02CON"
                                                            TipoPantalla="LISTADO" [FiltrosAvan]="1"
                                                            (eventoFiltros)="abrirFlexFiltros($event)">
                                                        </app-filtrocampo>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 offset-8 mt-3 btn-flex" style="text-align: right;">
                                <button type="button" class="btn btn-info btn-label waves-light" (click)="filtrar()">
                                    <i class="fa fa-filter label-icon" style="pointer-events:none;"></i> Buscar
                                </button>
                                <button type="button" class="btn btn-info btn-label waves-light" (click)="limpiar()">
                                    <i class="fa fa-broom label-icon" style="pointer-events:none;"></i> Limpiar
                                </button>
                            </div>
                        </div>  
                    </ng-container>

                    <div class="row mt-3">
                        <h4 class="letra-azul">{{SYS02DES}}</h4>
                    </div>

                    <div class="mb-4">
                        <!-- PivotView Syncfusion cargado lazy (chunk ui-heavy). Ver PivotComponent. -->
                        <app-lazy-heavy *ngIf="isFlex" type="pivot" [inputs]="pivotInputs"></app-lazy-heavy>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
